import {Modal} from 'shared/components/modals/index';
import EmailTemplatePreview from 'shared/components/EmailTemplatePreview';
import {observer} from 'mobx-react';

const EmailTemplatePreviewModal = observer(({isOpen, onHide, title, template}) => {
  return (
    <Modal
      isOpen={isOpen}
      onHide={() => onHide()}
      size='md'
      title={title}
    >
      <EmailTemplatePreview template={template}/>
    </Modal>
  );
});

export default EmailTemplatePreviewModal;
